import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./PopularProducts.module.sass";
import { Link } from "react-router-dom";
import Card from "../Card";
import { UseApi } from "../../hooks/use-api";
import { GetPopular } from "../../Services/lib/nft";
import { UseDisclosure } from "../../hooks/use-disclosure";
import ProductModal from "../ProductModal";
import home from "../../i11/Home";
import { useUser } from "../../context";

const PopularProducts = ({ className, views }) => {
	const { locale } = useUser();
	const [data, setData] = useState([]);
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [item, setItem] = useState();
	const [{}, fetch] = UseApi({
		service: GetPopular,
	});

	const getProd = async () => {
		let res = await fetch(views);
		if (res) {
			res = res.list.map((e) => {
				return {
					_id: e._id,
					title: e.name,
					status: e.status,
					image: e.image,
				};
			});
			setData(res);
		}
	};

	useEffect(() => {
		getProd();
	}, []);

	return (
		<>
			<Card
				className={cn(styles.card, className)}
				title={home[locale].popular_products}
				classTitle="title-blue"
			>
				<div className={styles.popular}>
					<div className={styles.head}>
						<div className={styles.stage}>{home[locale].products}</div>
						<div className={styles.stage}></div>
					</div>
					<div className={styles.list}>
						{data.map(
							(x, index) =>
								views > index && (
									<div
										className={styles.item}
										key={"elelleee" + index}
										onClick={() => {
											onOpen(true);
											setItem(x._id);
										}}
									>
										<div className={styles.preview}>
											<img src={x.image} alt="Product" />
										</div>
										<div className={styles.title}>{x.title}</div>
										<div className={styles.details}>
											<div className={cn("status-green", styles.status)}>
												{x.status}
											</div>
										</div>
									</div>
								)
						)}
					</div>
					<Link className={cn("button-stroke", styles.button)} to="/product">
						{home[locale].all_products}
					</Link>
				</div>
			</Card>
			<ProductModal
				visible={isOpen}
				onClose={() => {
					onClose();
					setItem();
				}}
				data={item}
				nfts
			/>
		</>
	);
};

export default PopularProducts;
